module.exports = __webpack_public_path__ + "more-info.6ba9f5d22684e4dd2d8f.svg";


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/assets/images/more-info.svg
// module id = ../../../../../src/assets/images/more-info.svg
// module chunks = styles